import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';

export const downloadPDF = (inputRef, pdfname) => {
  const input = inputRef?.current;
  const originalStyleOverflow = input.style.overflow;
  const originalStyleHeight = input.style.height;

  // Set overflow to 'auto' to ensure all content is rendered
  input.style.overflow = 'auto';
  input.style.height = 'auto';

  html2canvas(input, { scrollY: -window.scrollY, useCORS: true }).then((canvas) => {
    const imgData = canvas.toDataURL('image/png');
    const pdf = new jsPDF('p', 'mm', 'a4', true);
    const pdfwidth = pdf.internal.pageSize.getWidth();
    const pdfHeight = pdf.internal.pageSize.getHeight();
    const imgWidth = canvas.width;
    const imgHeight = canvas.height;
    const ratio = Math.min(pdfwidth / imgWidth, pdfHeight / imgHeight);
    const imgX = (pdfwidth - imgWidth * ratio) / 2;
    const imgY = 10;

    pdf.addImage(imgData, 'PNG', imgX, imgY, imgWidth * ratio, imgHeight * ratio);
    pdf.save(pdfname);

    // Reset styles after capturing content
    input.style.overflow = originalStyleOverflow;
    input.style.height = originalStyleHeight;
  });
};
